/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { css } from '@emotion/react'

export type ListingCardStyle =
  | string
  | {
      readonly base: string
      readonly desktop: string
    }

export type CardContainerProps = {
  readonly maxHeight: {
    readonly base: string
    readonly md: string
  }
  readonly maxWidth: string
  readonly minWidth: {
    readonly base: string
    readonly md: string
  }
  readonly boxShadow: string
  readonly borderRadius: string
  readonly scrollSnapAlign: string
}

export type CardContentContainerProps = {
  readonly p: string
}

export const listingCardContainer = (
  cardHeight: ListingCardStyle,
  cardBorder: ListingCardStyle,
  cardBorderRadius: ListingCardStyle,
  showBoxShadow: boolean,
  isSingleMargin: boolean,
  cardContainerProps?: CardContainerProps
) => css`
    display: flex;
    flex-direction: column;
    background: var(--chakra-colors-gray-0);
    border: ${typeof cardBorder === 'string' ? cardBorder : cardBorder.base};
    border-radius: ${
      cardContainerProps?.borderRadius
        ? cardContainerProps?.borderRadius
        : typeof cardBorderRadius === 'string'
          ? cardBorderRadius
          : cardBorderRadius.base
    };
    height: ${typeof cardHeight === 'string' ? cardHeight : cardHeight.base};
    max-height: ${
      cardContainerProps?.maxHeight.base
        ? cardContainerProps?.maxHeight.base
        : typeof cardHeight === 'string'
          ? cardHeight
          : cardHeight.base
    };
    box-shadow: ${
      cardContainerProps?.boxShadow
        ? cardContainerProps?.boxShadow
        : showBoxShadow
          ? '0px 8px 16px rgba(0, 0, 0, 0.12)'
          : 'none'
    };
    margin: ${isSingleMargin ? '1px' : '0 auto'};
    max-width: ${cardContainerProps?.maxWidth ?? '100%'};
    min-height: 230px;
    min-width: ${cardContainerProps?.minWidth.base ?? 'initial'};
    cursor: pointer;
    overflow: hidden;
    position: relative;
    scroll-snap-align: ${cardContainerProps?.scrollSnapAlign ?? 'initial'};

    @media (min-width: 768px) {
        border: ${typeof cardBorder === 'string' ? cardBorder : cardBorder.desktop};
        border-radius: ${
          typeof cardBorderRadius === 'string' ? cardBorderRadius : cardBorderRadius.desktop
        };
        height: ${typeof cardHeight === 'string' ? cardHeight : cardHeight.desktop};
        max-height: ${
          cardContainerProps?.maxHeight.md
            ? cardContainerProps?.maxHeight.md
            : typeof cardHeight === 'string'
              ? cardHeight
              : cardHeight.desktop
        };
        min-width: ${cardContainerProps?.minWidth.md ?? 'initial'};
    }
`

export const listingCardContentContainer = (
  bodyHeight: ListingCardStyle,
  bodyPadding: ListingCardStyle,
  cardContentContainerProps?: CardContentContainerProps
) => css`
    position: relative;
    height: ${typeof bodyHeight === 'string' ? bodyHeight : bodyHeight.base};
    padding: ${
      cardContentContainerProps?.p
        ? cardContentContainerProps?.p
        : typeof bodyPadding === 'string'
          ? bodyPadding
          : bodyPadding.base
    };

    @media (min-width: 768px) {
        height: ${typeof bodyHeight === 'string' ? bodyHeight : bodyHeight.desktop};
        padding: ${
          cardContentContainerProps?.p
            ? cardContentContainerProps?.p
            : typeof bodyPadding === 'string'
              ? bodyPadding
              : bodyPadding.desktop
        };
    }
`

export const bot = css`
    display: none;
`
